module.exports = __webpack_public_path__ + "media/advantage/handshake-99018e17.jpg";